<template>
  <div class="logobox">
    <!-- logo -->
    <img
      :src="require('@/assets/img/logo.png')"
      :class="['logo', {logoMedia:dev}]"
    >
  </div>
</template>

<script>
export default {
  name: "Logo",
  computed: {
    dev() {
      return this.$store.state.dev;
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/com.scss";
.logo {
  position: absolute;
  top: 0.96rem;
  right: 2.2rem;
  @include selectNone;
  @include wh(1.02rem);
}
.logoMedia {
  top: initial;
  bottom: -1rem;
  right: -0.5rem;
  @include rotate;
}
</style>


